import { render, staticRenderFns, recyclableRender, components } from "./sales-details.vue?vue&type=template&id=a4a437ec&scoped=true&"
var renderjs
import script from "./sales-details.vue?vue&type=script&lang=js&"
export * from "./sales-details.vue?vue&type=script&lang=js&"
import style0 from "./sales-details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sales-details.vue?vue&type=style&index=1&id=a4a437ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a437ec",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/sales-details/sales-details.vue"
export default component.exports